/* eslint-disable react/prefer-stateless-function */
import React, { Component } from "react"
import PropTypes from "prop-types"
import { createStructuredSelector } from "reselect"
import { connect } from "react-redux"
import isFeatureEnabled from "shared/featureflags/helperFunctions"

import {
    federalRegions,
    stateRegions,
    localRegions,
    federalAndStates,
    euRegion,
    euRegions,
    internationalRegions,
    usEURegion,
} from "shared/imports/regionConstants"

import {
    createProfileToggleFilter,
    createProfileToggleSingleFilter,
    datePickerGenericFilter,
    // sorting functions
    enumValueSort,
    enumLabelSort,
    enumPrecedenceSort,
    createSchoolDistrictEnrollmentFilter,
} from "shared/search/containers/Filter/Filters"
import {
    enumGenericFilter,
    searchifySelectGenericFilter,
    toggleGenericFilter,
} from "shared/search/containers/Filter/FilterCreators"

import {
    CaucusFilterableListView,
    CommitteeFilterableListView,
    CountySearchifyFLV,
    IssueManagementFilterableListView,
    MediaOutletSearchifyFLV,
    MunicipalitySearchifyFLV,
    PressContactFilterableListView,
    PublicOrganizationFilterableListView,
    PublicOrganizationPartyFilterableListView,
    SupporterFilterableListView,
    TrackingDashboardFilterableListView,
    OfficialFilterableWithoutCampaignFinanceListView,
} from "shared/search/containers/FilterableListView/FilterableListViews"

import {
    CaucusSelect,
    CommitteeSelect,
    ContactSelect,
    CountySelect,
    IssueManagementSelect,
    MediaOutletSelect,
    MunicipalitySelect,
    PressContactSelect,
    PublicOrganizationPartySelect,
    PublicOrganizationSelect,
    SchoolDistrictSelect,
    TrackingDashboardSelect,
    OfficialWithoutCampaignFinanceSelect,
} from "app/static/frontend/selects/containers/PieSelect"

import { selectIsCommsOnlyUser } from "shared/userdata/userdata-selectors"

export class DocumentTypeAxiosArticleFilter extends Component {
    static defaultProps = {
        filterComponent: enumGenericFilter,
        uniqueFilterId: "documentTypeFilter",
        componentKey: "axios_article",
        filterKey: "document_type__in",
        enumItems: DjangIO.app.document.models.DocumentType.region_supported_items(),
        enumGroups: DjangIO.app.document.models.DocumentType.filter_groups.filter(
            (group) => group.title === "Axios News Articles",
        ),
        sortBy: enumValueSort,
        regions: federalRegions,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class DocumentTypeStatementsFilter extends Component {
    static defaultProps = {
        filterComponent: enumGenericFilter,
        uniqueFilterId: "documentTypeFilter",
        componentKey: "statements", // disambiguate during rendering, since uniqueFilterId is shared
        filterKey: "document_type__in",
        enumItems: DjangIO.app.document.models.DocumentType.region_supported_items(),
        enumGroups: DjangIO.app.document.models.DocumentType.filter_groups
            // this is necessary because DocumentType.committee_report is shared between both US and EU
            // and we need to display it in a separate filter_group in the EU
            .filter((group) => group.title === "Statements"),
        sortBy: enumValueSort,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class DocumentTypeSocialFilter extends Component {
    static defaultProps = {
        filterComponent: enumGenericFilter,
        uniqueFilterId: "documentTypeFilter",
        componentKey: "social", // disambiguate during rendering, since uniqueFilterId is shared
        filterKey: "document_type__in",
        enumItems: DjangIO.app.document.models.DocumentType.region_supported_items().filter((item) => {
            if (!Userdata.isOnlyEUMode() && item.label === "Press Release") {
                return false
            } else {
                return true
            }
        }),
        enumGroups: DjangIO.app.document.models.DocumentType.filter_groups
            // this is necessary because DocumentType.committee_report is shared between both US and EU
            // and we need to display it in a separate filter_group in the EU
            .filter((group) => group.title === "Social"),
        sortBy: enumPrecedenceSort,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class DocumentTypeFilter extends Component {
    static defaultProps = {
        filterComponent: enumGenericFilter,
        uniqueFilterId: "documentTypeFilter",
        componentKey: "transcript", // disambiguate during rendering, since uniqueFilterId is shared
        filterKey: "document_type_is",
        enumItems: DjangIO.app.document.models.DocumentType.region_supported_items().filter(
            (item) => item.label !== "Instagram Post",
        ),
        enumGroups: DjangIO.app.document.models.DocumentType.filter_groups
            // this is necessary because DocumentType.committee_report is shared between both US and EU
            // and we need to display it in a separate filter_group in the EU
            .filter((group) => {
                if (
                    group.title === "Axios News Articles" ||
                    (Userdata.isOnlyEUMode() && group.title === "Reports") ||
                    (!Userdata.isOnlyEUMode() && group.title === "Parliament") ||
                    (!Userdata.isOnlyEUMode() && group.title === "European Commission") ||
                    group.title === "Statements" ||
                    group.title === "Social"
                ) {
                    return false
                } else {
                    return true
                }
            }),
        sortBy: enumValueSort,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class StateBillDocumentTypeFilter extends Component {
    static defaultProps = {
        filterComponent: enumGenericFilter,
        uniqueFilterId: "stateBillDocumentTypeFilter",
        filterKey: "for_state_bill",
        enumItems: DjangIO.app.bill.models.StateBillDocumentType.region_supported_items(),
        displayLabel: "State Bill Document Type",
        sortBy: enumValueSort,
        regions: stateRegions,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class DocumentTypeSocialOnlyFilter extends Component {
    static defaultProps = {
        filterComponent: enumGenericFilter,
        uniqueFilterId: "documentTypeFilter",
        componentKey: "social-only", // disambiguate during rendering, since uniqueFilterId is shared
        filterKey: "document_type__in",
        enumItems: DjangIO.app.document.models.DocumentType.region_supported_items(),
        enumGroups: DjangIO.app.document.models.DocumentType.filter_groups.filter((group) => group.title === "Social"),
        sortBy: enumValueSort,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export const DocumentCountyFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent searchifyFLV={CountySearchifyFLV} {...props} />
}
DocumentCountyFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "documentCounty",
    filterKey: "for_counties",
    selectComponent: CountySelect,
    dataTypeLabel: "Counties",
    regions: localRegions,
}

export const DocumentMunicipalityFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent searchifyFLV={MunicipalitySearchifyFLV} {...props} />
}
DocumentMunicipalityFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "documentMunicipality",
    filterKey: "for_municipalities",
    selectComponent: MunicipalitySelect,
    dataTypeLabel: "Municipalities",
    regions: localRegions,
}

export class DocumentSchoolDistrictFilter extends Component {
    static defaultProps = {
        filterComponent: searchifySelectGenericFilter,
        uniqueFilterId: "documentSchoolDistrict",
        filterKey: "searchify_source_public_organization",
        dataTypeLabel: "SchoolDistricts",
        selectComponent: SchoolDistrictSelect,
        searchifyFLV: PublicOrganizationFilterableListView,
        regions: localRegions,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class DocumentSourceTypeFilter extends Component {
    static defaultProps = {
        filterComponent: enumGenericFilter,
        uniqueFilterId: "documentSourceType",
        filterKey: "source_type__in",
        // filterKey: "doc_source_type", <--- bring this guy in once we get optimizations done
        enumItems: DjangIO.app.document.models.DocumentSourceType.region_supported_items().filter(
            (item) => item.label !== "Axios" || isFeatureEnabled("ff_axios_documents_integration"),
        ),
        sortBy: enumValueSort,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class DocumentPersonSourceFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "documentPersonSource",
            filterKey: "source_members",
            dataTypeLabel: "Officials",
            searchifyFLV: OfficialFilterableWithoutCampaignFinanceListView,
            displayLabel: "Documents from Officials",
            selectComponent: OfficialWithoutCampaignFinanceSelect,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

class UnconnectedDocumentPressContactSourceFilter extends Component {
    render() {
        const FilterComponent = this.props.filterComponent
        return (
            <FilterComponent
                {...this.props}
                displayLabel={`${this.props.isCommsOnlyUser ? "Tweets" : "Documents"} from Press Contacts`}
            />
        )
    }
}

export const DocumentPressContactSourceFilter = connect(
    createStructuredSelector({ isCommsOnlyUser: selectIsCommsOnlyUser }),
)(UnconnectedDocumentPressContactSourceFilter)
DocumentPressContactSourceFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "documentPressContactSource",
    filterKey: "source_members",
    dataTypeLabel: "PressContacts",
    searchifyFLV: PressContactFilterableListView,
    displayLabel: "Documents from Press Contacts",
    selectComponent: PressContactSelect,
    permissions: [DjangIO.app.models.PermissionType.media_relations],
}

class UnconnectedDocumentMediaOutletSourceFilter extends Component {
    render() {
        const FilterComponent = this.props.filterComponent
        return (
            <FilterComponent
                {...this.props}
                displayLabel={`${this.props.isCommsOnlyUser ? "Tweets" : "Documents"} by Media Outlet`}
            />
        )
    }
}

export const DocumentMediaOutletSourceFilter = connect(
    createStructuredSelector({ isCommsOnlyUser: selectIsCommsOnlyUser }),
)(UnconnectedDocumentMediaOutletSourceFilter)
DocumentMediaOutletSourceFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "documentMediaOutletSource",
    filterKey: "searchify_source_public_organization",
    dataTypeLabel: "MediaOutlets",
    searchifyFLV: MediaOutletSearchifyFLV,
    displayLabel: "Documents by Media Outlet",
    selectComponent: MediaOutletSelect,
    permissions: [DjangIO.app.models.PermissionType.media_relations],
}

export class DocumentCampaignSourceFilter extends Component {
    static defaultProps = {
        filterComponent: toggleGenericFilter,
        uniqueFilterId: "documentCampaignSource",
        filterKey: "campaign_source",
        trueText: "Legislative",
        falseText: "Campaign/Personal",
        regions: federalRegions,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class DocumentCurrentSourceFilter extends Component {
    static defaultProps = {
        filterComponent: toggleGenericFilter,
        uniqueFilterId: "documentCurrentSource",
        filterKey: "current_source",
        trueText: "Current Officials",
        falseText: "Former Officials",
        regions: federalAndStates,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class DocumentChamberFilter extends Component {
    static defaultProps = {
        filterComponent: enumGenericFilter,
        uniqueFilterId: "documentChamberFilter",
        filterKey: "chamber",
        enumItems: DjangIO.app.models.CongressChamber.region_supported_items(),
        displayLabel: "Chamber",
        regions: federalAndStates,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class DocumentPartyFilter extends Component {
    static defaultProps = {
        filterComponent: enumGenericFilter,
        uniqueFilterId: "documentPartyFilter",
        filterKey: "party",
        enumItems: DjangIO.app.person.types.Party.region_supported_items().filter(
            (item) => item.value !== DjangIO.app.person.types.Party.NoParty.value,
        ),
        sortBy: enumLabelSort,
        displayLabel: "Party",
        regions: usEURegion,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class DocumentPartyInternationalFilter extends Component {
    static defaultProps = {
        filterComponent: searchifySelectGenericFilter,
        uniqueFilterId: "documentPartyInternationalFilter",
        filterKey: "searchify_source_public_organization",
        displayLabel: "Parties",
        dataTypeLabel: "Parties",
        regions: internationalRegions,
        searchifyFLV: PublicOrganizationPartyFilterableListView,
        selectComponent: PublicOrganizationPartySelect,
        searchifyPermanentFilter: {
            non_custom_only: true,
            political_major_organization_type: true,
        },
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class DocumentSourceCommitteeFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "documentCommitteeSource",
            filterKey: "source_committee_filter",
            dataTypeLabel: "Committees",
            searchifyFLV: CommitteeFilterableListView,
            displayLabel: "Committee Documents",
            regions: federalAndStates.concat(euRegion),
            selectComponent: CommitteeSelect,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export const DocumentSourceCaucusFilter = (props) => {
    const FilterComponent = props.filterComponent
    return <FilterComponent searchifyFLV={CaucusFilterableListView} {...props} />
}
DocumentSourceCaucusFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "documentCaucusSource",
    filterKey: "source_caucus_filter",
    dataTypeLabel: "Caucuses",
    displayLabel: "Caucus Documents",
    regions: federalRegions,
    selectComponent: CaucusSelect,
}

export class DocumentLanguageFilter extends Component {
    static defaultProps = {
        filterComponent: enumGenericFilter,
        uniqueFilterId: "documentLanguageFilter",
        filterKey: "languages",
        enumItems: DjangIO.app.document.types.Language.region_supported_items(),
        sortBy: enumLabelSort,
        displayLabel: "Language",
        regions: euRegions,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class DocumentSupporterSourceFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "documentSupporterSource",
            filterKey: "associated_with_supporter",
            dataTypeLabel: "Contacts",
            searchifyFLV: SupporterFilterableListView,
            displayLabel: "Custom Contact Documents",
            permissions: [DjangIO.app.models.PermissionType.contacts_documents],
            selectComponent: ContactSelect,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class DocumentPublicOrganizationSourceFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "documentOrganizationSource",
            filterKey: "searchify_source_public_organization",
            dataTypeLabel: "Organizations",
            searchifyFLV: PublicOrganizationFilterableListView,
            displayLabel: "Organization Documents",
            selectComponent: PublicOrganizationSelect,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

// invisible filters for the purposes of graphs
// enumGenericFilter is specified because it has the serialization
// function that we want! (These filters are effectively enum
// filters, but with text.)
export class DocumentHashtagFilter extends Component {
    static defaultProps = {
        filterComponent: enumGenericFilter,
        uniqueFilterId: "documentHashtag",
        filterKey: "contains_hashtags",
        invisible: true,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class DocumentRetweetFilter extends Component {
    static defaultProps = {
        filterComponent: enumGenericFilter,
        uniqueFilterId: "documentRetweet",
        filterKey: "retweet_sources",
        invisible: true,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class DocumentMentionFilter extends Component {
    static defaultProps = {
        filterComponent: enumGenericFilter,
        uniqueFilterId: "documentMention",
        filterKey: "contains_mentions",
        invisible: true,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

// Profile-specfic filters
export const DocumentOrganizatonsFilter = createProfileToggleSingleFilter({
    uniqueFilterId: "documentOrganizatonsFilter",
    trueText: "Current Org Only",
    filterKeyMapping: {
        true: "associated_with_organization",
    },
})

export const DocumentMembersOrganizatonsFilter = createProfileToggleSingleFilter({
    uniqueFilterId: "documentMembersOrganizatonsFilter",
    trueText: "Current Org Only",
    filterKeyMapping: {
        true: "associated_officials_with_organization",
    },
})

export const DocumentProjectFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent searchifyFLV={IssueManagementFilterableListView} {...props} />
}
DocumentProjectFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    searchifyFLV: PropTypes.string,
    dataTypeLabel: PropTypes.string,
    selectComponent: PropTypes.func,
}
DocumentProjectFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "documentProjectFilter",
    filterKey: "for_project_and_subprojects",
    dataTypeLabel: "Issues",
    selectComponent: IssueManagementSelect,
}

export const DocumentIsRetweetFilter = (props) => {
    const FilterComponent = props.filterComponent || toggleGenericFilter
    return <FilterComponent {...props} />
}
DocumentIsRetweetFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    displayLabel: PropTypes.string,
    trueText: PropTypes.string,
    falseText: PropTypes.string,
}
DocumentIsRetweetFilter.defaultProps = {
    filterComponent: toggleGenericFilter,
    uniqueFilterId: "documentIsRetweetFilter",
    filterKey: "is_retweet",
    trueText: "Only Retweets",
    falseText: "No Retweets",
}

export const DocumentCommitteProfileFilter = createProfileToggleFilter({
    uniqueFilterId: "documentCommitteProfileFilter",
    trueText: "Committee + All Sub Committees",
    falseText: "Current Committee Only",
    filterKeyMapping: {
        true: "source_committees_or_mentions",
        false: "source_committee_or_mentions",
    },
})

export const DocumentTrackingDashboardFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent searchifyFLV={TrackingDashboardFilterableListView} {...props} />
}
DocumentTrackingDashboardFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    searchifyFLV: PropTypes.string,
    searchifyPermanentFilter: PropTypes.object,
    dataTypeLabel: PropTypes.string,
    selectComponent: PropTypes.func,
}
DocumentTrackingDashboardFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "documentTrackingDashboardFilter",
    filterKey: "for_tracking_dashboards",
    dataTypeLabel: "Tracking Dashboards",
    searchifyPermanentFilter: {
        data_type: DjangIO.app.models.QuorumDataType.document.value,
    },
    selectComponent: TrackingDashboardSelect,
}

export const DocumentDatePickerStartNoFutureFilter = (props) => {
    const FilterComponent = props.filterComponent
    return <FilterComponent {...props} />
}
DocumentDatePickerStartNoFutureFilter.defaultProps = {
    filterComponent: datePickerGenericFilter,
    uniqueFilterId: "documentDateStartNoFuture",
    filterKey: "date__gt",
    displayLabel: "Start Date",
    noFuture: true,
    helpText: "Documents start date selected. Excludes date selected.",
}

export const DocumentDatePickerEndNoFutureFilter = (props) => {
    const FilterComponent = props.filterComponent
    return <FilterComponent {...props} />
}
DocumentDatePickerEndNoFutureFilter.defaultProps = {
    filterComponent: datePickerGenericFilter,
    uniqueFilterId: "documentDateEndNoFuture",
    filterKey: "date__lt",
    displayLabel: "End Date",
    noFuture: true,
    helpText: "Documents end date selected. Excludes date selected.",
}

export const DocumentsRepresentingSchoolDistrictEnrollmentMinFilter = createSchoolDistrictEnrollmentFilter({
    uniqueFilterId: "document_rep_sd_enrollment_min",
    filterKey: "associated_sd_min_enrollment",
    isMin: true,
})

export const DocumentsRepresentingSchoolDistrictEnrollmentMaxFilter = createSchoolDistrictEnrollmentFilter({
    uniqueFilterId: "document_rep_sd_enrollment_max",
    filterKey: "associated_sd_max_enrollment",
    isMin: false,
})
